import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

export default function ConfirmDialog({
  open,
  onOpenChange,
  title = "Are you sure?",
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  destructive = false,
  loading = false,
}) {
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!loading) onOpenChange(v); }}>
      <DialogContent
        className="sm:max-w-md bg-white border-[#D4C7E1] rounded-2xl"
        data-testid="confirm-dialog"
      >
        <DialogHeader>
          <div className="flex items-center gap-2.5">
            {destructive && (
              <div className="h-9 w-9 rounded-full bg-[#F6ECEC] flex items-center justify-center shrink-0">
                <AlertTriangle className="h-4 w-4 text-[#C28A8A]" />
              </div>
            )}
            <DialogTitle className="text-2xl" style={{ fontFamily: "'Playfair Display', serif" }}>
              {title}
            </DialogTitle>
          </div>
          {description && (
            <DialogDescription className="text-[#75737A] pt-2 leading-relaxed">
              {description}
            </DialogDescription>
          )}
        </DialogHeader>

        <DialogFooter className="gap-2 pt-4">
          <Button
            type="button"
            variant="outline"
            className="rounded-full border-[#D4C7E1]"
            onClick={() => onOpenChange(false)}
            disabled={loading}
            data-testid="confirm-cancel-btn"
          >
            {cancelLabel}
          </Button>
          <Button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className={
              destructive
                ? "rounded-full px-6 bg-[#C28A8A] text-white hover:bg-[#A87373] disabled:opacity-50"
                : "btn-primary rounded-full px-6"
            }
            data-testid="confirm-action-btn"
          >
            {loading ? "Working…" : confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
